export enum SiteListActions {
    GET_SITE_LIST = 'GET_SITE_LIST',
    RESET_LIST = 'RESET_SITE_LIST',
    FILTER_LIST = 'FILTER_LIST',
}
